import React from 'react'
import './Button.css'

const joinClasses = (...classes) => classes.filter(Boolean).join(' ')

const Button = React.forwardRef(({
  children,
  variant = 'secondary',
  tone = 'neutral',
  size = 'md',
  shape = 'default',
  leftIcon,
  rightIcon,
  iconOnly = false,
  fullWidth = false,
  className = '',
  type = 'button',
  ...props
}, ref) => {
  const buttonClassName = joinClasses(
    'ui-button',
    `ui-button--${variant}`,
    `ui-button--${size}`,
    tone !== 'neutral' && `ui-button--tone-${tone}`,
    shape === 'pill' && 'ui-button--pill',
    shape === 'circle' && 'ui-button--circle',
    iconOnly && 'ui-button--icon-only',
    fullWidth && 'ui-button--full-width',
    className,
  )

  const iconOnlyContent = leftIcon || rightIcon || children

  return (
    <button className={buttonClassName} type={type} ref={ref} {...props}>
      {iconOnly ? (
        iconOnlyContent ? <span className='ui-button__icon'>{iconOnlyContent}</span> : null
      ) : (
        <>
          {leftIcon ? <span className='ui-button__icon'>{leftIcon}</span> : null}
          {children ? <span className='ui-button__label'>{children}</span> : null}
          {rightIcon ? <span className='ui-button__icon'>{rightIcon}</span> : null}
        </>
      )}
    </button>
  )
})

Button.displayName = 'Button'

export default Button
